import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { CommonserviceService } from '../Service/CommonService/commonservice.service';
import { Router, ActivatedRoute, ResolveData } from '@angular/router';

import { from, fromEvent } from 'rxjs';
import { Location, LocationStrategy, PlatformLocation } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../Service/auth/auth.service';


@Component({
    selector: 'app-underconstruction',
    templateUrl: './underconstruction.component.html',
    styleUrls: ['./underconstruction.component.css'],
    standalone: false
})


export class UnderconstructionComponent implements OnInit {
  title = 'KoinNation | Under Construction | KoinNation';
  constructor(location: LocationStrategy, private titleService: Title, private router: Router,private service: CommonserviceService, public authService: AuthService) {
    window.history.pushState(null, null, window.location.href);
    location.onPopState(() => {
      window.history.pushState(null, null, window.location.href);
    });
  }



  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    // this.service.getfunction('api/v1/site/view').subscribe(response => {
    //   if (!response.sitemode)
    //     this.service.SiteFunction(response);
    //   else
    //     this.router.navigate(['/under-construction'])
    // });
  }

}
